import React from "react";

import { STREAM_TYPE, DEFAULT_CARD_HEIGHT, TAG } from "config/constants";
import Stream from "stream/containers/Stream";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import LatestStories from "components/Library/LatestStories";
import FullStoryCard from "cards/containers/FullStoryCard";
import TagStreamHelmet from "stream/components/TagStreamHelmet";
import MidtermsTagStreamHeader from "stream/components/MidtermsTagStreamHeader";
import AxiosVisualsStreamCap from "stream/components/AxiosVisualsStreamCap";

class MidtermsTagStream extends React.Component {
  render() {
    return (
      <React.Fragment>
        <TagStreamHelmet slug={TAG.MIDTERM_ELECTIONS_2018.slug} />
        <MidtermsTagStreamHeader />
        <StandardLayout
          main={
            <React.Fragment>
              <AxiosVisualsStreamCap slug="2018-11-06-balance-of-power" />
              <Stream
                type={STREAM_TYPE.TAG}
                lookup={TAG.MIDTERM_ELECTIONS_2018.slug}
                onlyShowTitleForA11y={true}
                defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
                contentComponent={FullStoryCard}
              />
            </React.Fragment>
          }
          complementary={<LatestStories />}
          mainAriaLabel="Stories"
        />
      </React.Fragment>
    );
  }
}

export default MidtermsTagStream;
